module.exports = __webpack_public_path__ + "static/media/android-status-bar.393df2a1.svg";